import { SidebarTrigger, useSidebar } from "@altimateai/lego";

const ConditionalSidebarTrigger = () => {
  const { state } = useSidebar();

  if (state !== "collapsed") {
    return null;
  }

  return <SidebarTrigger className="al-absolute al-top-[-36px] al-left-[10px] al-z-[41]" />;
};

export default ConditionalSidebarTrigger;
